import styled from "styled-components";

import { alignItemsCenter } from "@styles/Utilities.styled";


export const StyledTableControls = styled.div`
  ${alignItemsCenter}
  gap: 0.25rem;
`;
